<script lang="ts" setup></script>

<template>
  <div class="city-select__empty">
    <div class="city-select__empty-title">Не нашли такого города</div>

    <div class="city-select__empty-text">
      Проверьте, нет ли опечатки? Если нет, поищите ближайший к вам крупный
      город
    </div>
  </div>
</template>

<style lang="scss" scoped>
.city-select {
  &__empty {
    min-height: 258px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 50px;

    &-title {
      margin: 4px;
      font-family: Onest, sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
    }

    &-text {
      font-family: Inter, sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #b0b6c3;
    }
  }
}
</style>
